<template>
  <div class="min-h-screen overflow-hidden">
    <section class="md:pt-16 pt-5">
      <div class="">
        <div>
          <div>
            <div class="sm:hidden flex items-center justify-center mb-5">
              <NuxtLink
                :to="$localePath('/')"
                class="flex items-center text-2xl space-x-0.5"
              >
                <img
                  src="@/assets/images/hero/logo_large_transparent.webp"
                  alt="Medium Logo"
                  class="h-18"
                />
              </NuxtLink>
            </div>

            <div
              class="sm:flex hidden items-center justify-center bg-white w-fit mx-auto mb-10 gap-3 px-5 py-2.5 border border-gray-200 rounded-full font-medium backdrop-blur"
            >
              <span class="uppercase text-sm">Medium.am</span>
            </div>

            <h1
              class="text-center lg:w-3/5 sm:w-3/4 mx-auto font-extrabold"
              :class="getTitleClasses"
            >
              {{ $t("hero.title") }}
            </h1>

            <div class="flex flex-col items-center space-y-5 mt-10">
              <p
                class="text-gray-500 text-base text-center sm:max-w-md sm:px-0 px-5"
              >
                {{ $t("hero.description") }}
              </p>
              <ClientOnly>
                <BaseButton
                  @click="handleHeroCTA"
                  size="md"
                  :label="user ? $t('nav.links.new_artwork') : $t('hero.cta')"
                  class="sm:min-w-48 sm:w-auto sm:mx-0 mx-auto rounded-lg transition-all hover:-translate-y-1 hover:shadow"
                >
                  <template #icon>
                    <Icon
                      :name="user ? 'ph:plus' : 'ph:caret-right'"
                      size="20"
                    />
                  </template>
                </BaseButton>

                <p class="text-center mt-2.5" v-if="!user">
                  {{ $t("hero.login_prompt") }}
                  <NuxtLink
                    :to="$localePath('/auth/login')"
                    class="text-primary-blue transition-all duration-200 hover:underline"
                  >
                    {{ $t("hero.login_link") }}
                  </NuxtLink>
                </p>
              </ClientOnly>
            </div>
          </div>

          <div class="flex my-8 justify-center flex-1">
            <img
              src="@/assets/images/hero/collage-3.webp"
              class="h-100 mx-auto md:hidden block"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { AppUser } from "~~/types/user";
import { useNewArtworkStore } from "~/stores/artwork.new";

const { locale } = useI18n();
const auth = useAuthStore();
const newArtStore = useNewArtworkStore();
const localePath = useLocalePath();

const user = useState<AppUser | null>("auth-user", () => null);

const getTitleClasses = computed<string>(() =>
  locale.value === "en"
    ? " text-center 2xl:text-[110px] md:text-7xl text-5xl md:text-7xl lg:text-7xl text-primary font-bold"
    : locale.value === "hy"
      ? "2xl:text-[95px] md:text-7xl text-4xl"
      : "2xl:text-[90px] md:text-7xl text-4xl",
);

const handleHeroCTA = async () => {
  if (user.value) {
    newArtStore.openNewArtwork();
    return;
  }
  await navigateTo(localePath("/auth/register"));
};
</script>

<style scoped>
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}

.rainbow::before {
  content: "";
  position: absolute;
  z-index: -2;
  left: -50%;
  top: -50%;
  width: 200%;
  height: 200%;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 50% 30%;
  filter: blur(6px);
  background-image: linear-gradient(#140101);
  animation: rotate 4s linear infinite;
}
</style>
